import {Button, ButtonGroup, Card, Radio, RadioGroup, TextArea, TextField} from "@nike/eds";
import {Type} from "./Type";
import {edsSpace16, edsSpace32} from "@nike/eds/dist/tokens";
import {useState} from "react";
import {mapInventoryLocation} from "./LocationMapper";
import DSLeftCWConfirmModal from "./DSLeftCWConfirmModal";

export function DSLeftCW({dSLeftCWService}) {

    const [formState, setFormState] = useState({
        quantity: 0,
        type: Type.BONDED_DECON,
        location: "NIPPGNK",
        shipments: "",
        shipmentList: [] as string[],
        shipmentsHasErrors: false,
        shipmentsErrorMessage: "",
        reason: "Missing Milestone - MS",
        reasonHasErrors: false,
        reasonErrorMessage: "",
        comment: "",
    })

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const resetFormState = () => {
        setFormState({
            quantity: 0,
            type: Type.BONDED_DECON,
            location: "NIPPGNK",
            shipments: "",
            shipmentList: [] as string[],
            shipmentsHasErrors: false,
            shipmentsErrorMessage: "",
            reason: "Missing Milestone - MS",
            reasonHasErrors: false,
            reasonErrorMessage: "",
            comment: "",
        });
    }

    const openModal = () => {
        setModalIsOpen(true);
    }

    const closeModal = (isConfirmed) => {
        setModalIsOpen(false);
        if (isConfirmed) {
            resetFormState()
        }
    }

    const formGroupStyle = {
        marginBottom: edsSpace16
    }

    const formGroupLastItemStyle = {
        marginBottom: edsSpace32
    }

    const radioGroupStyle = {
        width: "fit-content",
    }

    const handleInputChange = (key: string, value: any) => {
        setFormState((prevState) => ({
            ...prevState,
            [key]: value
        }));
        if (key === "type") {
            changeLocation(value);
        }
    };

    const changeLocation = (value: any) => {
        const location = value === Type.BONDED_DECON ? "NIPPGNK" : "TRANSIT";
        setFormState((prevState) => ({
            ...prevState,
            location: location
        }));
    };

    const validateForm = () => {
        const { reason, shipments } = formState;

        let reasonErrorMessage = "";
        let reasonHasError = false;
        let shipmentsErrorMessage = "";
        let shipmentsHasError = false;
        let shipmentListTemp: string[] = [];

        if (reason.trim() === "") {
            reasonErrorMessage = "No reason entered";
            reasonHasError = true;
        }

        if (shipments.trim() === "") {
            shipmentsErrorMessage = "No SAP Shipment ID added";
            shipmentsHasError = true;
        } else {
            shipments.split(/[\r\n;]+/).forEach((shipment) => {
                const shipmentTrimmed = shipment.trim();
                if (shipmentTrimmed !== "") {
                    shipmentListTemp.push(shipmentTrimmed)
                }
            });
        }

        setFormState((prevState) => ({
            ...prevState,
            reasonHasErrors: reasonHasError,
            reasonErrorMessage,
            shipmentsHasErrors: shipmentsHasError,
            shipmentsErrorMessage,
            shipmentList: shipmentListTemp
        }))

        if (!reasonHasError && !shipmentsHasError) {
            openModal();
        }
    }
    

    return (
        <div className="eds-grid eds-elevation--4">
            <Card>
                <div className="form-group" style={formGroupStyle}>
                    <RadioGroup label="Type"
                                name="typeRadioGroup"
                                valueSelected={formState.type}
                                onChange={(e) => handleInputChange("type", e.target.value as Type)}
                                className="eds-radio-group eds-grid eds-grid--m-cols-2"
                                style={radioGroupStyle}
                    >
                        <Radio label={Type.BONDED_DECON} value={Type.BONDED_DECON} id="type_radio_1"/>
                        <Radio label={Type.DIRECT_DIRECT} value={Type.DIRECT_DIRECT} id="type_radio_2"/>
                    </RadioGroup>
                </div>

                <div className="form-group" style={formGroupStyle}>
                    <TextField id="location_text_field" label="Location" value={mapInventoryLocation(formState.location)} readOnly={true} message={" "}/>
                </div>

                <div className="form-group" style={formGroupStyle}>
                    <TextArea
                        value={formState.shipments}
                        onChange={e => handleInputChange("shipments", e.target.value)}
                        showCount
                        id="shipments_text_area"
                        hasErrors={formState.shipmentsHasErrors}
                        errorMessage={formState.shipmentsErrorMessage}
                        placeholder="Click to add SAP Shipment IDs"
                        label="SAP Shipment ID"
                        autoResize
                    />
                </div>

                <div className="form-group" style={formGroupStyle}>
                    <TextField id="reason_text_field" label="Reason" value={formState.reason} message={" "}
                               onChange={(e) => handleInputChange("reason", e.target.value)}
                               hasErrors={formState.reasonHasErrors}
                               errorMessage={formState.reasonErrorMessage}/>
                </div>

                <div className="form-group form-group-last-item" style={formGroupLastItemStyle}>
                    <TextField id="comment_text_field" label="Comment" value={formState.comment}
                               onChange={(e) => handleInputChange("comment", e.target.value)}
                               placeholder="Click to add a comment ..."/>
                </div>

                <div className="form-group form-group-last-item" style={formGroupStyle}>
                    <ButtonGroup>
                        <Button variant="primary" type="submit" onClick={validateForm}>Trigger event</Button>
                    </ButtonGroup>
                </div>

            </Card>

            {modalIsOpen && (
                <DSLeftCWConfirmModal isOpen={modalIsOpen} onClose={closeModal} type={formState.type}
                                      location={formState.location} shipmentIds={formState.shipmentList}
                                      reason={formState.reason} comment={formState.comment} dSLeftCWService={dSLeftCWService}></DSLeftCWConfirmModal>
            )}
        </div>
    );
}